module.exports = __webpack_public_path__ + "img/section3Card1logo4.a2e3b1e6.png";